import { render, staticRenderFns } from "./NavigationHeader.vue?vue&type=template&id=0ba6ef47&"
import script from "./NavigationHeader.vue?vue&type=script&lang=js&"
export * from "./NavigationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports